import { IconArrowSmallBack } from '@medifind/icons';
import { useRouter } from '@medifind/router';
import { selectHistory, useHistoryStore } from '@medifind/zustand';
import { Button } from './inputs/Button';

const BackButton = ({ className, style, color, label, iconOnlyAt, buttonType, iconColor }) => {
  const router = useRouter();
  const history = useHistoryStore(selectHistory);
  return (
    <>
      {history.length > 1 && (
        <Button
          className={className}
          style={style}
          type={buttonType || 'thin'}
          label={label || 'Back'}
          color={color || 'light-blue'}
          iconBefore={<IconArrowSmallBack color={iconColor} />}
          onClick={() => router.history.goBack()}
          iconOnlyAt={iconOnlyAt}
        />
      )}
    </>
  );
};

export { BackButton as default, BackButton };
